(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["sh-3fold-landing"] && !Shopify.designMode) return;
  try {
    
(function(){
  var root=document.currentScript ? document.currentScript.closest('.shopify-section') : null;
  var scope=(root||document).querySelector('.sh3f');
  if(!scope) scope=document;
  var modal=scope.querySelector('[data-sh3f-modal]');
  if(modal){
    [].slice.call(scope.querySelectorAll('[data-sh3f-inst]')).forEach(function(b){ b.addEventListener('click', function(e){ e.preventDefault(); modal.hidden=false; }); });
    [].slice.call(modal.querySelectorAll('[data-sh3f-close]')).forEach(function(b){ b.addEventListener('click', function(){ modal.hidden=true; }); });
    document.addEventListener('keydown', function(e){ if(e.key==='Escape') modal.hidden=true; });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sh-accessory-landing"] && !Shopify.designMode) return;
  try {
    
(function(){
  var root=document.currentScript ? document.currentScript.closest('.shopify-section') : null;
  var scope=(root||document).querySelector('.shac');
  if(!scope) scope=document;
  var modal=scope.querySelector('[data-shac-modal]');
  if(modal){
    [].slice.call(scope.querySelectorAll('[data-shac-inst]')).forEach(function(b){ b.addEventListener('click', function(e){ e.preventDefault(); modal.hidden=false; }); });
    [].slice.call(modal.querySelectorAll('[data-shac-close]')).forEach(function(b){ b.addEventListener('click', function(){ modal.hidden=true; }); });
    document.addEventListener('keydown', function(e){ if(e.key==='Escape') modal.hidden=true; });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sh-atlantis-landing"] && !Shopify.designMode) return;
  try {
    
(function(){
  var root=document.currentScript&&document.currentScript.closest?document.currentScript.closest('.shopify-section'):document;
  root=root||document;
  var dataEl=root.querySelector('#sha-finder-data');
  if(!dataEl)return;
  var R; try{R=JSON.parse(dataEl.textContent);}catch(e){return;}
  function $(id){return root.querySelector('#'+id);}
  var els={img:$('sha-rc-img'),badge:$('sha-rc-badge'),disc:$('sha-rc-disc'),link:$('sha-rc-link'),name:$('sha-rc-name'),feel:$('sha-rc-feel'),price:$('sha-rc-price'),old:$('sha-rc-old'),save:$('sha-rc-save'),inst:$('sha-rc-inst'),tags:$('sha-rc-tags'),cart:$('sha-rc-cart'),detail:$('sha-rc-detail')};
  function apply(it){
    if(els.img){els.img.src=it.img;els.img.alt='ที่นอนรุ่น '+it.name;}
    if(els.badge)els.badge.textContent=it.badge;
    if(els.disc)els.disc.textContent=it.disc||'';
    if(els.name)els.name.textContent=it.name;
    if(els.feel)els.feel.textContent=it.feel;
    if(els.price)els.price.textContent=it.price;
    if(els.old){els.old.textContent=it.hasc?it.old:'';els.old.style.display=it.hasc?'':'none';}
    if(els.save)els.save.textContent=it.hasc?('ประหยัดสูงสุด ฿'+it.save):'';
    if(els.inst)els.inst.innerHTML='ผ่อน 0% นาน 10 เดือน · เริ่ม '+it.inst+'/เดือน <a href="#" class="sha-inst-more" data-sha-inst>ดูเงื่อนไข</a>';
    if(els.tags)els.tags.innerHTML=it.tags.map(function(t){return '<span class="sha-tag">'+t+'</span>';}).join('');
    if(els.link)els.link.href=it.url;
    if(els.detail)els.detail.href=it.url;
    if(els.cart){els.cart.setAttribute('data-variants',JSON.stringify(it.vars||[]));els.cart.setAttribute('data-pname',it.name);}
  }
  var POOL={value:['value'],cool:['cool'],balanced:['balanced','pro'],firm:['firm'],max:['max']};
  function pick(f){var a=POOL[f]||[f];var it=R[a[Math.floor(Math.random()*a.length)]]||R[f];if(it)apply(it);}
  pick('value');
  root.querySelectorAll('.sha-choice').forEach(function(b){
    b.addEventListener('click',function(){
      var f=b.getAttribute('data-choice'); if(!R[f]&&!POOL[f])return;
      root.querySelectorAll('.sha-choice').forEach(function(x){x.classList.remove('sha-active');});
      b.classList.add('sha-active');
      pick(f);
    });
  });
  var fchips=root.querySelector('#sha-chips');
  if(fchips){
    fchips.addEventListener('click',function(e){
      var b=e.target.closest('.sha-chip'); if(!b)return;
      fchips.querySelectorAll('.sha-chip').forEach(function(x){x.classList.remove('sha-active');});
      b.classList.add('sha-active');
      pick(b.getAttribute('data-sha-f'));
    });
  }
  // smooth scroll for in-page anchors
  root.querySelectorAll('a[href^="#sha-"]').forEach(function(a){
    a.addEventListener('click',function(e){
      var sel=a.getAttribute('href');
      var t=root.querySelector(sel)||document.querySelector(sel);
      if(t){e.preventDefault();var y=t.getBoundingClientRect().top+window.pageYOffset-80;window.scrollTo({top:y,behavior:'smooth'});}
    });
  });

  // ===== size popup (เลือกขนาด) → /cart/add.js → theme cart drawer (F-285) =====
  var pop=root.querySelector('#sha-sizepop');
  if(pop){
    var spList=root.querySelector('#sha-sp-list'), spName=root.querySelector('#sha-sp-name'), spAdd=root.querySelector('#sha-sp-add');
    var cur={vs:null,sel:null};
    function closePop(){pop.classList.remove('sha-open');pop.setAttribute('aria-hidden','true');}
    function openPop(){pop.classList.add('sha-open');pop.setAttribute('aria-hidden','false');}
    function selRow(i){
      var rows=spList.children,k;
      for(k=0;k<rows.length;k++)rows[k].classList.remove('sha-sel');
      if(rows[i])rows[i].classList.add('sha-sel');
      cur.sel=cur.vs[i];
      spAdd.disabled=false;spAdd.textContent='ใส่ตะกร้า';
    }
    function buildSize(vs,pname){
      cur={vs:vs,sel:null};
      spName.textContent=pname||'';
      spList.innerHTML='';spAdd.disabled=true;spAdd.textContent='เลือกขนาดก่อน';
      var firstOk=-1;
      vs.forEach(function(v,i){
        var title=String(v.title||'');
        var size=title.split('(')[0].trim();
        var m=title.match(/\(([^)]+)\)/);
        var sub=m?m[1]:'';
        var row=document.createElement('div');
        row.className='sha-sizerow'+(v.ok?'':' sha-oos');
        var cmp=v.cmp?'<span class="sha-cmp">'+v.cmp+'</span>':'';
        var oos=v.ok?'':'<span class="sha-sizerow__oos">สินค้าหมด</span>';
        row.innerHTML='<div class="sha-sizerow__left"><span class="sha-sz">'+size+'</span>'+(sub?'<span class="sha-szs">('+sub+')</span>':'')+'</div><div class="sha-sizerow__right">'+cmp+'<span class="sha-pr">'+v.price+'</span></div>'+oos;
        if(v.ok){row.addEventListener('click',(function(idx){return function(){selRow(idx);};})(i));if(firstOk<0)firstOk=i;}
        spList.appendChild(row);
      });
      if(firstOk>=0)selRow(firstOk);
      openPop();
    }
    root.querySelectorAll('[data-sizepop]').forEach(function(btn){
      btn.addEventListener('click',function(e){
        e.preventDefault();
        var vs;try{vs=JSON.parse(btn.getAttribute('data-variants')||'[]');}catch(err){vs=[];}
        if(!vs.length)return;
        vs.sort(function(a,b){return (parseFloat(a.title)||0)-(parseFloat(b.title)||0);});
        buildSize(vs,btn.getAttribute('data-pname'));
      });
    });
    spAdd.addEventListener('click',function(){
      if(!cur.sel||!cur.sel.ok)return;
      spAdd.disabled=true;spAdd.textContent='กำลังเพิ่ม…';
      fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:cur.sel.id,quantity:1}]})})
        .then(function(r){if(!r.ok)throw new Error('add failed');return r.json();})
        .then(function(){
          closePop();spAdd.textContent='ใส่ตะกร้า';
          var cl=document.querySelector('a.hdt-has-count-box[href$="/cart"]')||document.querySelector('a.hdt-has-count-box[href*="/cart"]');
          if(cl){cl.click();}
          // match PDP "added" drawer look (collection only): title + reveal gift campaign box without waiting for refresh
          setTimeout(function(){
            var dr=document.querySelector('[data-cart-drawer]'); if(!dr)return;
            var t=dr.querySelector('.sh-cart-drawer__head-title');
            if(t){[].forEach.call(t.childNodes,function(n){if(n.nodeType===3&&n.textContent.trim())n.textContent='เพิ่มลงตะกร้าแล้ว';});}
            dr.querySelectorAll('.sh-cart-drawer__gifts:not([data-cart-realgifts])').forEach(function(g){g.style.display='';});
          },80);
        })
        .catch(function(){spAdd.disabled=false;spAdd.textContent='ลองอีกครั้ง';});
    });
    pop.querySelectorAll('[data-sp-close]').forEach(function(x){x.addEventListener('click',closePop);});
    document.addEventListener('keydown',function(e){if(e.key==='Escape'&&pop.classList.contains('sha-open'))closePop();});
  }

  // installment terms modal (เกณฑ์ผ่อน 0%) — delegated so dynamic finder link works too
  var instModal=root.querySelector('[data-sha-modal]');
  if(instModal){
    root.addEventListener('click',function(e){ if(e.target.closest('[data-sha-inst]')){ e.preventDefault(); instModal.hidden=false; } });
    instModal.querySelectorAll('[data-sha-close]').forEach(function(b){ b.addEventListener('click',function(){ instModal.hidden=true; }); });
    document.addEventListener('keydown',function(e){ if(e.key==='Escape') instModal.hidden=true; });
  }

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sh-b2b-landing"] && !Shopify.designMode) return;
  try {
    
(function(){})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sh-bedbase-landing"] && !Shopify.designMode) return;
  try {
    
(function(){
  var root=document.currentScript ? document.currentScript.closest('.shopify-section') : null;
  var scope=(root||document).querySelector('.shbb');
  if(!scope) scope=document;
  var modal=scope.querySelector('[data-shbb-modal]');
  if(modal){
    [].slice.call(scope.querySelectorAll('[data-shbb-inst]')).forEach(function(b){ b.addEventListener('click', function(e){ e.preventDefault(); modal.hidden=false; }); });
    [].slice.call(modal.querySelectorAll('[data-shbb-close]')).forEach(function(b){ b.addEventListener('click', function(){ modal.hidden=true; }); });
    document.addEventListener('keydown', function(e){ if(e.key==='Escape') modal.hidden=true; });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sh-bedding-landing"] && !Shopify.designMode) return;
  try {
    
(function(){
  var root=document.currentScript ? document.currentScript.closest('.shopify-section') : null;
  var scope=(root||document).querySelector('.shbd');
  if(!scope) scope=document;
  var chipBox=scope.querySelector('[data-shbd-chips="sheet"]');
  var grid=scope.querySelector('[data-shbd-grid="sheet"]');
  if(chipBox&&grid){
    var chips=[].slice.call(chipBox.querySelectorAll('.shbd-chip'));
    var cards=[].slice.call(grid.querySelectorAll('.shbd-card'));
    chips.forEach(function(ch){ ch.addEventListener('click', function(){
      var f=ch.getAttribute('data-shbd-filter');
      cards.forEach(function(c){ var t=c.getAttribute('data-tags')||''; c.style.display=(f==='all'||t.split(' ').indexOf(f)>-1)?'':'none'; });
      chips.forEach(function(x){ x.classList.toggle('is-active', x===ch); });
    }); });
  }
  var modal=scope.querySelector('[data-shbd-modal]');
  if(modal){
    [].slice.call(scope.querySelectorAll('[data-shbd-inst]')).forEach(function(b){ b.addEventListener('click', function(e){ e.preventDefault(); modal.hidden=false; }); });
    [].slice.call(modal.querySelectorAll('[data-shbd-close]')).forEach(function(b){ b.addEventListener('click', function(){ modal.hidden=true; }); });
    document.addEventListener('keydown', function(e){ if(e.key==='Escape') modal.hidden=true; });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sh-bolster-landing"] && !Shopify.designMode) return;
  try {
    
(function(){
  var root=document.currentScript ? document.currentScript.closest('.shopify-section') : null;
  var scope=(root||document).querySelector('.shbl');
  if(!scope) scope=document;
  var chipBox=scope.querySelector('[data-shbl-chips]');
  var grid=scope.querySelector('[data-shbl-grid]');
  if(chipBox&&grid){
    var chips=[].slice.call(chipBox.querySelectorAll('.shbl-chip'));
    var cards=[].slice.call(grid.querySelectorAll('.shbl-card'));
    chips.forEach(function(ch){ ch.addEventListener('click', function(){
      var f=ch.getAttribute('data-shbl-filter');
      cards.forEach(function(c){ var t=c.getAttribute('data-tags')||''; c.style.display=(f==='all'||t.split(' ').indexOf(f)>-1)?'':'none'; });
      chips.forEach(function(x){ x.classList.toggle('is-active', x===ch); });
    }); });
  }
  var modal=scope.querySelector('[data-shbl-modal]');
  if(modal){
    [].slice.call(scope.querySelectorAll('[data-shbl-inst]')).forEach(function(b){ b.addEventListener('click', function(e){ e.preventDefault(); modal.hidden=false; }); });
    [].slice.call(modal.querySelectorAll('[data-shbl-close]')).forEach(function(b){ b.addEventListener('click', function(){ modal.hidden=true; }); });
    document.addEventListener('keydown', function(e){ if(e.key==='Escape') modal.hidden=true; });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sh-duvet-landing"] && !Shopify.designMode) return;
  try {
    
(function(){
  var root=document.currentScript ? document.currentScript.closest('.shopify-section') : null;
  var scope=(root||document).querySelector('.shdv');
  if(!scope) scope=document;
  var modal=scope.querySelector('[data-shdv-modal]');
  if(modal){
    [].slice.call(scope.querySelectorAll('[data-shdv-inst]')).forEach(function(b){ b.addEventListener('click', function(e){ e.preventDefault(); modal.hidden=false; }); });
    [].slice.call(modal.querySelectorAll('[data-shdv-close]')).forEach(function(b){ b.addEventListener('click', function(){ modal.hidden=true; }); });
    document.addEventListener('keydown', function(e){ if(e.key==='Escape') modal.hidden=true; });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sh-element-landing"] && !Shopify.designMode) return;
  try {
    
(function(){
  var root=document.currentScript&&document.currentScript.closest?document.currentScript.closest('.shopify-section'):document;
  root=root||document;
  var dataEl=root.querySelector('#shel-finder-data');
  if(!dataEl)return;
  var R; try{R=JSON.parse(dataEl.textContent);}catch(e){return;}
  function $(id){return root.querySelector('#'+id);}
  var els={img:$('shel-rc-img'),badge:$('shel-rc-badge'),disc:$('shel-rc-disc'),link:$('shel-rc-link'),name:$('shel-rc-name'),feel:$('shel-rc-feel'),price:$('shel-rc-price'),old:$('shel-rc-old'),save:$('shel-rc-save'),inst:$('shel-rc-inst'),tags:$('shel-rc-tags'),cart:$('shel-rc-cart'),detail:$('shel-rc-detail')};
  function apply(it){
    if(els.img){els.img.src=it.img;els.img.alt='ที่นอนรุ่น '+it.name;}
    if(els.badge)els.badge.textContent=it.badge;
    if(els.disc)els.disc.textContent=it.disc||'';
    if(els.name)els.name.textContent=it.name;
    if(els.feel)els.feel.textContent=it.feel;
    if(els.price)els.price.textContent=it.price;
    if(els.old){els.old.textContent=it.hasc?it.old:'';els.old.style.display=it.hasc?'':'none';}
    if(els.save)els.save.textContent=it.hasc?('ประหยัดสูงสุด ฿'+it.save):'';
    if(els.inst)els.inst.innerHTML='ผ่อน 0% นาน 10 เดือน · เริ่ม '+it.inst+'/เดือน <a href="#" class="shel-inst-more" data-shel-inst>ดูเงื่อนไข</a>';
    if(els.tags)els.tags.innerHTML=it.tags.map(function(t){return '<span class="shel-tag">'+t+'</span>';}).join('');
    if(els.link)els.link.href=it.url;
    if(els.detail)els.detail.href=it.url;
    if(els.cart){els.cart.setAttribute('data-variants',JSON.stringify(it.vars||[]));els.cart.setAttribute('data-pname',it.name);}
  }
  function pick(f){var it=R[f];if(it)apply(it);}
  pick('budget');
  root.querySelectorAll('.shel-choice').forEach(function(b){
    b.addEventListener('click',function(){
      var f=b.getAttribute('data-choice'); if(!R[f])return;
      root.querySelectorAll('.shel-choice').forEach(function(x){x.classList.remove('shel-active');});
      b.classList.add('shel-active');
      pick(f);
    });
  });
  var fchips=root.querySelector('#shel-chips');
  if(fchips){
    fchips.addEventListener('click',function(e){
      var b=e.target.closest('.shel-chip'); if(!b)return;
      fchips.querySelectorAll('.shel-chip').forEach(function(x){x.classList.remove('shel-active');});
      b.classList.add('shel-active');
      pick(b.getAttribute('data-shel-f'));
    });
  }
  // smooth scroll for in-page anchors
  root.querySelectorAll('a[href^="#shel-"]').forEach(function(a){
    a.addEventListener('click',function(e){
      var sel=a.getAttribute('href');
      var t=root.querySelector(sel)||document.querySelector(sel);
      if(t){e.preventDefault();var y=t.getBoundingClientRect().top+window.pageYOffset-80;window.scrollTo({top:y,behavior:'smooth'});}
    });
  });

  // ===== size popup (เลือกขนาด) → /cart/add.js → theme cart drawer (F-285) =====
  var pop=root.querySelector('#shel-sizepop');
  if(pop){
    var spList=root.querySelector('#shel-sp-list'), spName=root.querySelector('#shel-sp-name'), spAdd=root.querySelector('#shel-sp-add');
    var cur={vs:null,sel:null};
    function closePop(){pop.classList.remove('shel-open');pop.setAttribute('aria-hidden','true');}
    function openPop(){pop.classList.add('shel-open');pop.setAttribute('aria-hidden','false');}
    function selRow(i){
      var rows=spList.children,k;
      for(k=0;k<rows.length;k++)rows[k].classList.remove('shel-sel');
      if(rows[i])rows[i].classList.add('shel-sel');
      cur.sel=cur.vs[i];
      spAdd.disabled=false;spAdd.textContent='ใส่ตะกร้า';
    }
    function buildSize(vs,pname){
      cur={vs:vs,sel:null};
      spName.textContent=pname||'';
      spList.innerHTML='';spAdd.disabled=true;spAdd.textContent='เลือกขนาดก่อน';
      var firstOk=-1;
      vs.forEach(function(v,i){
        var title=String(v.title||'');
        var size=title.split('(')[0].trim();
        var m=title.match(/\(([^)]+)\)/);
        var sub=m?m[1]:'';
        var row=document.createElement('div');
        row.className='shel-sizerow'+(v.ok?'':' shel-oos');
        var cmp=v.cmp?'<span class="shel-cmp">'+v.cmp+'</span>':'';
        var oos=v.ok?'':'<span class="shel-sizerow__oos">สินค้าหมด</span>';
        row.innerHTML='<div class="shel-sizerow__left"><span class="shel-sz">'+size+'</span>'+(sub?'<span class="shel-szs">('+sub+')</span>':'')+'</div><div class="shel-sizerow__right">'+cmp+'<span class="shel-pr">'+v.price+'</span></div>'+oos;
        if(v.ok){row.addEventListener('click',(function(idx){return function(){selRow(idx);};})(i));if(firstOk<0)firstOk=i;}
        spList.appendChild(row);
      });
      if(firstOk>=0)selRow(firstOk);
      openPop();
    }
    root.querySelectorAll('[data-sizepop]').forEach(function(btn){
      btn.addEventListener('click',function(e){
        e.preventDefault();
        var vs;try{vs=JSON.parse(btn.getAttribute('data-variants')||'[]');}catch(err){vs=[];}
        if(!vs.length)return;
        vs.sort(function(a,b){return (parseFloat(a.title)||0)-(parseFloat(b.title)||0);});
        buildSize(vs,btn.getAttribute('data-pname'));
      });
    });
    spAdd.addEventListener('click',function(){
      if(!cur.sel||!cur.sel.ok)return;
      spAdd.disabled=true;spAdd.textContent='กำลังเพิ่ม…';
      fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:cur.sel.id,quantity:1}]})})
        .then(function(r){if(!r.ok)throw new Error('add failed');return r.json();})
        .then(function(){
          closePop();spAdd.textContent='ใส่ตะกร้า';
          var cl=document.querySelector('a.hdt-has-count-box[href$="/cart"]')||document.querySelector('a.hdt-has-count-box[href*="/cart"]');
          if(cl){cl.click();}
          // match PDP "added" drawer look (collection only): title + reveal gift campaign box without waiting for refresh
          setTimeout(function(){
            var dr=document.querySelector('[data-cart-drawer]'); if(!dr)return;
            var t=dr.querySelector('.sh-cart-drawer__head-title');
            if(t){[].forEach.call(t.childNodes,function(n){if(n.nodeType===3&&n.textContent.trim())n.textContent='เพิ่มลงตะกร้าแล้ว';});}
            dr.querySelectorAll('.sh-cart-drawer__gifts:not([data-cart-realgifts])').forEach(function(g){g.style.display='';});
          },80);
        })
        .catch(function(){spAdd.disabled=false;spAdd.textContent='ลองอีกครั้ง';});
    });
    pop.querySelectorAll('[data-sp-close]').forEach(function(x){x.addEventListener('click',closePop);});
    document.addEventListener('keydown',function(e){if(e.key==='Escape'&&pop.classList.contains('shel-open'))closePop();});
  }

  // installment terms modal (เกณฑ์ผ่อน 0%) — delegated so dynamic finder link works too
  var instModal=root.querySelector('[data-shel-modal]');
  if(instModal){
    root.addEventListener('click',function(e){ if(e.target.closest('[data-shel-inst]')){ e.preventDefault(); instModal.hidden=false; } });
    instModal.querySelectorAll('[data-shel-close]').forEach(function(b){ b.addEventListener('click',function(){ instModal.hidden=true; }); });
    document.addEventListener('keydown',function(e){ if(e.key==='Escape') instModal.hidden=true; });
  }

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sh-hotel-landing"] && !Shopify.designMode) return;
  try {
    
(function(){
  var root=document.currentScript&&document.currentScript.closest?document.currentScript.closest('.shopify-section'):document;
  root=root||document;
  var dataEl=root.querySelector('#shh-finder-data');
  if(!dataEl)return;
  var R; try{R=JSON.parse(dataEl.textContent);}catch(e){return;}
  function $(id){return root.querySelector('#'+id);}
  var els={img:$('shh-rc-img'),badge:$('shh-rc-badge'),disc:$('shh-rc-disc'),link:$('shh-rc-link'),name:$('shh-rc-name'),feel:$('shh-rc-feel'),price:$('shh-rc-price'),old:$('shh-rc-old'),save:$('shh-rc-save'),inst:$('shh-rc-inst'),tags:$('shh-rc-tags'),cart:$('shh-rc-cart'),detail:$('shh-rc-detail')};
  function apply(it){
    if(els.img){els.img.src=it.img;els.img.alt='ที่นอนรุ่น '+it.name;}
    if(els.badge)els.badge.textContent=it.badge;
    if(els.disc)els.disc.textContent=it.disc||'';
    if(els.name)els.name.textContent=it.name;
    if(els.feel)els.feel.textContent=it.feel;
    if(els.price)els.price.textContent=it.price;
    if(els.old){els.old.textContent=it.hasc?it.old:'';els.old.style.display=it.hasc?'':'none';}
    if(els.save)els.save.textContent=it.hasc?('ประหยัดสูงสุด ฿'+it.save):'';
    if(els.inst)els.inst.innerHTML='ผ่อน 0% นาน 10 เดือน · เริ่ม '+it.inst+'/เดือน <a href="#" class="shh-inst-more" data-shh-inst>ดูเงื่อนไข</a>';
    if(els.tags)els.tags.innerHTML=it.tags.map(function(t){return '<span class="shh-tag">'+t+'</span>';}).join('');
    if(els.link)els.link.href=it.url;
    if(els.detail)els.detail.href=it.url;
    if(els.cart){els.cart.setAttribute('data-variants',JSON.stringify(it.vars||[]));els.cart.setAttribute('data-pname',it.name);}
  }
  var POOL={};
  function pick(f){var a=POOL[f]||[f];var it=R[a[Math.floor(Math.random()*a.length)]]||R[f];if(it)apply(it);}
  pick('balanced');
  root.querySelectorAll('.shh-choice').forEach(function(b){
    b.addEventListener('click',function(){
      var f=b.getAttribute('data-choice'); if(!R[f]&&!POOL[f])return;
      root.querySelectorAll('.shh-choice').forEach(function(x){x.classList.remove('shh-active');});
      b.classList.add('shh-active');
      pick(f);
    });
  });
  var fchips=root.querySelector('#shh-chips');
  if(fchips){
    fchips.addEventListener('click',function(e){
      var b=e.target.closest('.shh-chip'); if(!b)return;
      fchips.querySelectorAll('.shh-chip').forEach(function(x){x.classList.remove('shh-active');});
      b.classList.add('shh-active');
      pick(b.getAttribute('data-shh-f'));
    });
  }
  // smooth scroll for in-page anchors
  root.querySelectorAll('a[href^="#shh-"]').forEach(function(a){
    a.addEventListener('click',function(e){
      var sel=a.getAttribute('href');
      var t=root.querySelector(sel)||document.querySelector(sel);
      if(t && getComputedStyle(t).display==='none'){var fb=root.querySelector('#shh-feel');if(fb && getComputedStyle(fb).display!=='none')t=fb;}
      if(t){e.preventDefault();var y=t.getBoundingClientRect().top+window.pageYOffset-80;window.scrollTo({top:y,behavior:'smooth'});}
    });
  });

  // ===== size popup (เลือกขนาด) → /cart/add.js → theme cart drawer (F-285) =====
  var pop=root.querySelector('#shh-sizepop');
  if(pop){
    var spList=root.querySelector('#shh-sp-list'), spName=root.querySelector('#shh-sp-name'), spAdd=root.querySelector('#shh-sp-add');
    var cur={vs:null,sel:null};
    function closePop(){pop.classList.remove('shh-open');pop.setAttribute('aria-hidden','true');}
    function openPop(){pop.classList.add('shh-open');pop.setAttribute('aria-hidden','false');}
    function selRow(i){
      var rows=spList.children,k;
      for(k=0;k<rows.length;k++)rows[k].classList.remove('shh-sel');
      if(rows[i])rows[i].classList.add('shh-sel');
      cur.sel=cur.vs[i];
      spAdd.disabled=false;spAdd.textContent='ใส่ตะกร้า';
    }
    function buildSize(vs,pname){
      cur={vs:vs,sel:null};
      spName.textContent=pname||'';
      spList.innerHTML='';spAdd.disabled=true;spAdd.textContent='เลือกขนาดก่อน';
      var firstOk=-1;
      vs.forEach(function(v,i){
        var title=String(v.title||'');
        var size=title.split('(')[0].trim();
        var m=title.match(/\(([^)]+)\)/);
        var sub=m?m[1]:'';
        var row=document.createElement('div');
        row.className='shh-sizerow'+(v.ok?'':' shh-oos');
        var cmp=v.cmp?'<span class="shh-cmp">'+v.cmp+'</span>':'';
        var oos=v.ok?'':'<span class="shh-sizerow__oos">สินค้าหมด</span>';
        row.innerHTML='<div class="shh-sizerow__left"><span class="shh-sz">'+size+'</span>'+(sub?'<span class="shh-szs">('+sub+')</span>':'')+'</div><div class="shh-sizerow__right">'+cmp+'<span class="shh-pr">'+v.price+'</span></div>'+oos;
        if(v.ok){row.addEventListener('click',(function(idx){return function(){selRow(idx);};})(i));if(firstOk<0)firstOk=i;}
        spList.appendChild(row);
      });
      if(firstOk>=0)selRow(firstOk);
      openPop();
    }
    root.querySelectorAll('[data-sizepop]').forEach(function(btn){
      btn.addEventListener('click',function(e){
        e.preventDefault();
        var vs;try{vs=JSON.parse(btn.getAttribute('data-variants')||'[]');}catch(err){vs=[];}
        if(!vs.length)return;
        vs.sort(function(a,b){return (parseFloat(a.title)||0)-(parseFloat(b.title)||0);});
        buildSize(vs,btn.getAttribute('data-pname'));
      });
    });
    spAdd.addEventListener('click',function(){
      if(!cur.sel||!cur.sel.ok)return;
      spAdd.disabled=true;spAdd.textContent='กำลังเพิ่ม…';
      fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:cur.sel.id,quantity:1}]})})
        .then(function(r){if(!r.ok)throw new Error('add failed');return r.json();})
        .then(function(){
          closePop();spAdd.textContent='ใส่ตะกร้า';
          var cl=document.querySelector('a.hdt-has-count-box[href$="/cart"]')||document.querySelector('a.hdt-has-count-box[href*="/cart"]');
          if(cl){cl.click();}
          // match PDP "added" drawer look (collection only): title + reveal gift campaign box without waiting for refresh
          setTimeout(function(){
            var dr=document.querySelector('[data-cart-drawer]'); if(!dr)return;
            var t=dr.querySelector('.sh-cart-drawer__head-title');
            if(t){[].forEach.call(t.childNodes,function(n){if(n.nodeType===3&&n.textContent.trim())n.textContent='เพิ่มลงตะกร้าแล้ว';});}
            dr.querySelectorAll('.sh-cart-drawer__gifts:not([data-cart-realgifts])').forEach(function(g){g.style.display='';});
          },80);
        })
        .catch(function(){spAdd.disabled=false;spAdd.textContent='ลองอีกครั้ง';});
    });
    pop.querySelectorAll('[data-sp-close]').forEach(function(x){x.addEventListener('click',closePop);});
    document.addEventListener('keydown',function(e){if(e.key==='Escape'&&pop.classList.contains('shh-open'))closePop();});
  }

  // installment terms modal (เกณฑ์ผ่อน 0%) — delegated so dynamic finder link works too
  var instModal=root.querySelector('[data-shh-modal]');
  if(instModal){
    root.addEventListener('click',function(e){ if(e.target.closest('[data-shh-inst]')){ e.preventDefault(); instModal.hidden=false; } });
    instModal.querySelectorAll('[data-shh-close]').forEach(function(b){ b.addEventListener('click',function(){ instModal.hidden=true; }); });
    document.addEventListener('keydown',function(e){ if(e.key==='Escape') instModal.hidden=true; });
  }

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sh-mattress-landing"] && !Shopify.designMode) return;
  try {
    
(function(){
  var root = document.currentScript ? document.currentScript.closest('.shopify-section') : null;
  var scope = (root || document).querySelector('.shm'); if(!scope) scope = document;
  function setupFilter(key){
    var box = scope.querySelector('[data-chips="'+key+'"]');
    var grid = scope.querySelector('[data-grid="'+key+'"]');
    if(!box || !grid) return;
    var chips = [].slice.call(box.querySelectorAll('.shm-chip'));
    var cards = [].slice.call(grid.children);
    box.addEventListener('click', function(e){
      var b = e.target.closest('.shm-chip'); if(!b) return;
      var f = b.getAttribute('data-filter');
      cards.forEach(function(c){ var t=c.getAttribute('data-tags')||''; c.style.display=(f==='all'||t.split(' ').indexOf(f)>-1)?'':'none'; });
      chips.forEach(function(x){ x.classList.toggle('shm-active', x===b); });
    });
  }
  setupFilter('coll'); setupFilter('prod');
  var m = scope.querySelector('.shm-modal');
  if(m){
    [].slice.call(scope.querySelectorAll('[data-inst]')).forEach(function(b){ b.addEventListener('click', function(e){ e.preventDefault(); m.hidden=false; }); });
    [].slice.call(m.querySelectorAll('[data-close]')).forEach(function(b){ b.addEventListener('click', function(){ m.hidden=true; }); });
    document.addEventListener('keydown', function(e){ if(e.key==='Escape') m.hidden=true; });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sh-othermatt-landing"] && !Shopify.designMode) return;
  try {
    
(function(){
  var root=document.currentScript ? document.currentScript.closest('.shopify-section') : null;
  var scope=(root||document).querySelector('.shom');
  if(!scope) scope=document;
  var modal=scope.querySelector('[data-shom-modal]');
  if(modal){
    [].slice.call(scope.querySelectorAll('[data-shom-inst]')).forEach(function(b){ b.addEventListener('click', function(e){ e.preventDefault(); modal.hidden=false; }); });
    [].slice.call(modal.querySelectorAll('[data-shom-close]')).forEach(function(b){ b.addEventListener('click', function(){ modal.hidden=true; }); });
    document.addEventListener('keydown', function(e){ if(e.key==='Escape') modal.hidden=true; });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sh-pillow-landing"] && !Shopify.designMode) return;
  try {
    
(function(){
  var root=document.currentScript ? document.currentScript.closest('.shopify-section') : null;
  var scope=(root||document).querySelector('.shp');
  if(!scope) scope=document;
  function setupFilter(chipsKey, gridKey){
    var chipBox=scope.querySelector('[data-shp-chips="'+chipsKey+'"]');
    var grid=scope.querySelector('[data-shp-grid="'+gridKey+'"]');
    if(!chipBox||!grid) return function(){};
    var chips=[].slice.call(chipBox.querySelectorAll('.shp-chip'));
    var cards=[].slice.call(grid.querySelectorAll('.shp-card'));
    function apply(f){
      cards.forEach(function(c){ var t=c.getAttribute('data-tags')||''; c.style.display=(f==='all'||t.split(' ').indexOf(f)>-1)?'':'none'; });
      chips.forEach(function(x){ x.classList.toggle('is-active', x.getAttribute('data-shp-filter')===f); });
    }
    chips.forEach(function(ch){ ch.addEventListener('click', function(){ apply(ch.getAttribute('data-shp-filter')); }); });
    return apply;
  }
  var pillowFilter=setupFilter('pillow','pillow');
  setupFilter('bolster','bolster');
  // category jump
  [].slice.call(scope.querySelectorAll('[data-shp-jump]')).forEach(function(c){
    c.addEventListener('click', function(e){ e.preventDefault();
      var id=c.getAttribute('data-shp-jump');
      if(id==='shp-pillows') pillowFilter('all');
      var el=document.getElementById(id); if(el) el.scrollIntoView({behavior:'smooth'});
    });
  });
  // guide options
  [].slice.call(scope.querySelectorAll('[data-shp-go]')).forEach(function(o){
    o.addEventListener('click', function(){
      var g=o.getAttribute('data-shp-go');
      if(g==='bolster'){ var b=document.getElementById('shp-bolsters'); if(b) b.scrollIntoView({behavior:'smooth'}); return; }
      if(g) pillowFilter(g);
      var p=document.getElementById('shp-pillows'); if(p) p.scrollIntoView({behavior:'smooth'});
    });
  });
  // installment modal
  var modal=scope.querySelector('[data-shp-modal]');
  if(modal){
    [].slice.call(scope.querySelectorAll('[data-shp-inst]')).forEach(function(b){ b.addEventListener('click', function(e){ e.preventDefault(); modal.hidden=false; }); });
    [].slice.call(modal.querySelectorAll('[data-shp-close]')).forEach(function(b){ b.addEventListener('click', function(){ modal.hidden=true; }); });
    document.addEventListener('keydown', function(e){ if(e.key==='Escape') modal.hidden=true; });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sh-pillowonly-landing"] && !Shopify.designMode) return;
  try {
    
(function(){
  var root=document.currentScript ? document.currentScript.closest('.shopify-section') : null;
  var scope=(root||document).querySelector('.shpo');
  if(!scope) scope=document;
  var chipBox=scope.querySelector('[data-shpo-chips]');
  var grid=scope.querySelector('[data-shpo-grid]');
  if(chipBox&&grid){
    var chips=[].slice.call(chipBox.querySelectorAll('.shpo-chip'));
    var cards=[].slice.call(grid.querySelectorAll('.shpo-card'));
    chips.forEach(function(ch){ ch.addEventListener('click', function(){
      var f=ch.getAttribute('data-shpo-filter');
      cards.forEach(function(c){ var t=c.getAttribute('data-tags')||''; c.style.display=(f==='all'||t.split(' ').indexOf(f)>-1)?'':'none'; });
      chips.forEach(function(x){ x.classList.toggle('is-active', x===ch); });
    }); });
  }
  var modal=scope.querySelector('[data-shpo-modal]');
  if(modal){
    [].slice.call(scope.querySelectorAll('[data-shpo-inst]')).forEach(function(b){ b.addEventListener('click', function(e){ e.preventDefault(); modal.hidden=false; }); });
    [].slice.call(modal.querySelectorAll('[data-shpo-close]')).forEach(function(b){ b.addEventListener('click', function(){ modal.hidden=true; }); });
    document.addEventListener('keydown', function(e){ if(e.key==='Escape') modal.hidden=true; });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sh-pillows-landing"] && !Shopify.designMode) return;
  try {
    
(function(){
  var root=document.currentScript&&document.currentScript.closest?document.currentScript.closest('.shopify-section'):document;
  root=root||document;
  root.querySelectorAll('a[href^="#shpw-"]').forEach(function(a){
    a.addEventListener('click',function(e){
      var sel=a.getAttribute('href');
      var t=root.querySelector(sel)||document.querySelector(sel);
      if(t){e.preventDefault();var y=t.getBoundingClientRect().top+window.pageYOffset-80;window.scrollTo({top:y,behavior:'smooth'});}
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sh-protector-landing"] && !Shopify.designMode) return;
  try {
    
(function(){
  var root=document.currentScript ? document.currentScript.closest('.shopify-section') : null;
  var scope=(root||document).querySelector('.shpr');
  if(!scope) scope=document;
  var modal=scope.querySelector('[data-shpr-modal]');
  if(modal){
    [].slice.call(scope.querySelectorAll('[data-shpr-inst]')).forEach(function(b){ b.addEventListener('click', function(e){ e.preventDefault(); modal.hidden=false; }); });
    [].slice.call(modal.querySelectorAll('[data-shpr-close]')).forEach(function(b){ b.addEventListener('click', function(){ modal.hidden=true; }); });
    document.addEventListener('keydown', function(e){ if(e.key==='Escape') modal.hidden=true; });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sh-search-landing"] && !Shopify.designMode) return;
  try {
    
(function(){
  var R=document.querySelector('[data-shse]');
  if(!R||R.dataset.shseInit)return;
  R.dataset.shseInit='1';
  var cfg=JSON.parse(R.querySelector('[data-shse-cfg]').textContent),T=cfg.t;
  var ROOT=cfg.root;
  if(ROOT.slice(-1)!=='/')ROOT+='/';
  var input=R.querySelector('[data-shse-input]'),grid=R.querySelector('[data-shse-grid]'),status=R.querySelector('[data-shse-status]'),nores=R.querySelector('[data-shse-nores]'),nq=R.querySelector('[data-shse-nq]'),cats=R.querySelector('[data-shse-cats]'),clearB=R.querySelector('[data-shse-clear]'),form=R.querySelector('[data-shse-form]');
  var chips=[].slice.call(R.querySelectorAll('[data-cat]'));
  var CAT='all',ITEMS=null,deb=null;
  var vw=new URLSearchParams(location.search).get('view');
  if(vw&&form){var hv=document.createElement('input');hv.type='hidden';hv.name='view';hv.value=vw;form.appendChild(hv);}
  var EXC={'cube-pillow':1,'cloud-soft-seta':1,'mattress-atlantis-v2-lite':1};
  var BOL={'polyester-bolster':1,'microfiber-bolster':1,'idream-ihug':1};
  var TOPS={'extra-firm-topper':1,'cloudy-topper':1,'microfiber-topper':1,'microfiber-topper-v2':1,'soft-cloud-topper':1};
  var DUV={'cooling-duvet':1,'cloud-duvet':1,'2-tone-cloud-duvet':1,'duvet-cover':1,'microfiber-duvet':1};
  var EXT={'bed-base':1,'bed-base-head-board':1,'drysoft-bath-towel':1,'luxury-hotel-soft-touch-towel-set':1};
  var BS={'atlantis-v2-pro':1,'hotel-ecstasy':1,'extra-firm-topper':1,'idream-ihug':1,'iadjust-coolgel-memory-foam-pillow':1};
  var POP=['atlantis-v2-pro','hotel-ecstasy','atlantis-max-hybrid','mattress-paradise','iadjust-coolgel-memory-foam-pillow','extra-firm-topper','hotel-bed-sheet-pillow-case','cooling-duvet','cube-memory-foam-pillow','microfiber-topper','latex-pillow','element-bounce','splendid','majestic-hybrid-14','atlantis-v2-lite','gravity'];
  var HOTEL={'hotel-ecstasy':1,'mattress-passion':1,'splendid':1,'mattress-paradise':1,'majestic-hybrid-14':1};
  var SYN=[['ยางพารา','latex'],['เมมโมรี่','เมมโมรี','memory'],['สปริง','spring'],['เย็น','cool'],['นุ่ม','soft'],['แน่น','firm'],['ขนเป็ด','duck down'],['ไมโครไฟเบอร์','microfiber'],['โรงแรม','hotel'],['ผ้าเช็ดตัว','ผ้าขนหนู','towel'],['ฐานเตียง','หัวเตียง','bed base','เตียง'],['กันน้ำ','waterproof'],['ปิคนิค','picnic','3 พับ','3พับ','สามพับ','3 fold','fold']];
  var CATAL={'หมอนข้าง':'bolster','bolster':'bolster','หมอนกอด':'bolster','ปลอกหมอน':'bedding','pillowcase':'bedding','ผ้าปู':'bedding','sheet':'bedding','ผ้านวม':'duvet','duvet':'duvet','นวม':'duvet','ผ้ารอง':'protector','กันเปื้อน':'protector','protector':'protector','ท็อปเปอร์':'topper','ทอปเปอร์':'topper','topper':'topper','หมอนหนุน':'pillow','หมอน':'pillow','pillow':'pillow','ที่นอน':'mattress','mattress':'mattress','ฟูก':'mattress'};
  function catOf(p){
    var h=p.handle,ty=p.product_type||'';
    if(BOL[h])return 'bolster';
    if(TOPS[h])return 'topper';
    if(DUV[h])return 'duvet';
    if(ty==='Protector')return 'protector';
    if(/Bed Sheet|Pillow Case|Bolster Case/.test(ty))return 'bedding';
    if(EXT[h])return 'extra';
    if(ty==='Pillows')return 'pillow';
    if(ty==='Accessories')return 'extra';
    return 'mattress';
  }
  function getCat(cb){
    if(ITEMS)return cb(ITEMS);
    var key='shse2'+ROOT;
    try{var c=sessionStorage.getItem(key);if(c){var o=JSON.parse(c);if(Date.now()-o.ts<600000){ITEMS=o.i;return cb(ITEMS);}}}catch(e){}
    fetch(ROOT+'products.json?limit=250').then(function(r){return r.json();}).then(function(d){
      var out=[];
      d.products.forEach(function(p){
        if(EXC[p.handle])return;
        var avs=[],alls=[];
        p.variants.forEach(function(v){var pr=parseFloat(v.price)||0;if(pr<=0)return;var o={p:pr,c:parseFloat(v.compare_at_price)||0};alls.push(o);if(v.available)avs.push(o);});
        if(!alls.length)return;
        var pool=avs.length?avs:alls;
        var best=pool.reduce(function(a,b){return b.p<a.p?b:a;});
        var pi=-1;
        POP.some(function(x,i){if(p.handle.indexOf(x)===0){pi=i;return true;}return false;});
        out.push({h:p.handle,t:p.title,img:(p.images&&p.images[0])?p.images[0].src:'',p:best.p,c:best.c,av:avs.length>0,cat:catOf(p),pop:pi<0?99:pi,
          hay:(p.title+' '+(p.tags||[]).join(' ')+' '+(p.product_type||'')+' '+p.handle).toLowerCase()});
      });
      ITEMS=out;
      try{sessionStorage.setItem(key,JSON.stringify({ts:Date.now(),i:out}));}catch(e){}
      cb(out);
    }).catch(function(){cb(null);});
  }
  function money(n){return n.toLocaleString('en-US',{minimumFractionDigits:2,maximumFractionDigits:2})+' ฿';}
  function money0(n){return n.toLocaleString('en-US',{minimumFractionDigits:0,maximumFractionDigits:2});}
  function esc(s){return String(s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/"/g,'&quot;');}
  function card(it){
    var url=ROOT+'products/'+it.h;
    var has=it.c>it.p;
    var pct=has?Math.round((it.c-it.p)*100/it.c):0;
    var im=it.img?it.img+(it.img.indexOf('?')>-1?'&':'?')+'width=600':'';
    return '<article class="shse-card'+(it.av?'':' is-oos')+'">'+
      '<div class="shse-card__media"><a class="shse-card__mlink" href="'+url+'" aria-label="'+esc(it.t)+'" style="position:absolute;inset:0;z-index:1"></a>'+
      (im?'<img src="'+im+'" alt="'+esc(it.t)+'" loading="lazy" width="600" height="600">':'')+
      (!it.av?'<span class="shse-card__disc shse-card__disc--oos">'+T.oos+'</span>':(has?'<span class="shse-card__disc">-'+pct+'%</span>':''))+
      ((BS[it.h]&&it.av)?'<span class="shse-card__bs">BEST SELLER</span>':'')+
      '</div><div class="shse-card__body">'+
      '<h3 class="shse-card__name"><a href="'+url+'">'+esc(it.t)+'</a></h3>'+
      '<div class="shse-card__prices"><span class="shse-card__price">'+money(it.p)+'</span>'+(has?'<span class="shse-card__cmp">'+money(it.c)+'</span>':'')+'</div>'+
      (has?'<p class="shse-card__save">'+T.save.replace('%s',money0(it.c-it.p))+'</p>':'')+
      '<a class="shse-card__btn" href="'+url+'">'+T.view+'</a>'+
      '</div></article>';
  }
  function tokHit(it,tok){
    if(it.hay.indexOf(tok)>-1)return true;
    var cal=CATAL[tok];
    if(cal&&it.cat===cal)return true;
    if((tok==='hotel'||tok==='โรงแรม')&&HOTEL[it.h])return true;
    for(var i=0;i<SYN.length;i++){
      var g=SYN[i],inG=false,j;
      for(j=0;j<g.length;j++){if(tok===g[j]||(tok.length>2&&g[j].indexOf(tok)===0)){inG=true;break;}}
      if(!inG)continue;
      for(j=0;j<g.length;j++){if(it.hay.indexOf(g[j])>-1)return true;}
    }
    return false;
  }
  function srt(a,b){
    if(a.av!==b.av)return a.av?-1:1;
    if(a.sc!==b.sc)return b.sc-a.sc;
    if(a.pop!==b.pop)return a.pop-b.pop;
    return a.p-b.p;
  }
  function run(){
    var q=input.value.trim();
    clearB.hidden=!q;
    getCat(function(items){
      if(!items)return;
      var list,mode;
      if(!q){
        if(CAT==='all'){mode='best';list=items.filter(function(i){return i.pop<99&&i.av;}).slice();list.sort(srt);list=list.slice(0,8);}
        else{mode='cat';list=items.filter(function(i){return i.cat===CAT;});list.forEach(function(i){i.sc=0;});list.sort(srt);}
      }else{
        mode='q';
        var ql=q.toLowerCase(),toks=ql.split(/\s+/).filter(Boolean);
        list=items.filter(function(it){
          if(CAT!=='all'&&it.cat!==CAT)return false;
          for(var i=0;i<toks.length;i++){if(!tokHit(it,toks[i]))return false;}
          return true;
        });
        var qcal=CATAL[ql];
        list.forEach(function(it){
          var s=0,tl=it.t.toLowerCase();
          if(qcal&&it.cat===qcal)s+=4;
          if(tl.indexOf(ql)>-1)s+=3;
          var all=true;
          for(var i=0;i<toks.length;i++){if(tl.indexOf(toks[i])<0){all=false;break;}}
          if(all)s+=2;
          it.sc=s;
        });
        list.sort(srt);
      }
      var pager=grid.querySelector('[data-shse-pager]');
      if(pager)pager.remove();
      grid.innerHTML=list.map(card).join('');
      var label='';
      if(mode==='best')label=T.best;
      else if(mode==='cat'){var ac=chips.filter(function(c){return c.getAttribute('data-cat')===CAT;})[0];label=T.catn.replace('%c',ac?ac.textContent.trim():'').replace('%n',list.length);}
      else label=T.found.replace('%n',list.length).replace('%q',q);
      status.textContent=label;
      var none=list.length===0;
      nores.hidden=!none;
      if(nq)nq.textContent=q;
      cats.hidden=!(none||!q);
      try{
        var sp=new URLSearchParams(location.search);
        if(q){sp.set('q',q);sp.set('type','product');}else{sp.delete('q');sp.delete('type');}
        var qs=sp.toString();
        history.replaceState(null,'',location.pathname+(qs?'?'+qs:''));
      }catch(e){}
    });
  }
  function debRun(){clearTimeout(deb);deb=setTimeout(run,220);}
  input.addEventListener('input',debRun);
  form.addEventListener('submit',function(e){e.preventDefault();clearTimeout(deb);run();input.blur();});
  clearB.addEventListener('click',function(){input.value='';run();input.focus();});
  var rs=R.querySelector('[data-shse-reset]');
  if(rs)rs.addEventListener('click',function(){input.value='';run();});
  chips.forEach(function(ch){
    ch.addEventListener('click',function(){
      CAT=ch.getAttribute('data-cat');
      chips.forEach(function(x){x.classList.toggle('is-active',x===ch);});
      run();
    });
  });
  [].slice.call(R.querySelectorAll('[data-shse-pill]')).forEach(function(a){
    a.addEventListener('click',function(e){e.preventDefault();input.value=a.getAttribute('data-shse-pill');run();});
  });
  if(window.innerWidth>900&&!input.value)try{input.focus();}catch(e){}
  run();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sh-topper-landing-p"] && !Shopify.designMode) return;
  try {
    
(function(){
  var root=document.currentScript ? document.currentScript.closest('.shopify-section') : null;
  var scope=(root||document).querySelector('.shtp2');
  if(!scope) scope=document;
  function setupFilter(chipsKey, gridKey){
    var chipBox=scope.querySelector('[data-shtp2-chips="'+chipsKey+'"]');
    var grid=scope.querySelector('[data-shtp2-grid="'+gridKey+'"]');
    if(!chipBox||!grid) return function(){};
    var chips=[].slice.call(chipBox.querySelectorAll('.shtp2-chip'));
    var cards=[].slice.call(grid.querySelectorAll('.shtp2-card'));
    function apply(f){
      cards.forEach(function(c){ var t=c.getAttribute('data-tags')||''; c.style.display=(f==='all'||t.split(' ').indexOf(f)>-1)?'':'none'; });
      chips.forEach(function(x){ x.classList.toggle('is-active', x.getAttribute('data-shtp2-filter')===f); });
    }
    chips.forEach(function(ch){ ch.addEventListener('click', function(){ apply(ch.getAttribute('data-shtp2-filter')); }); });
    return apply;
  }
  var pillowFilter=setupFilter('pillow','pillow');
  setupFilter('bolster','bolster');
  // category jump
  [].slice.call(scope.querySelectorAll('[data-shtp2-jump]')).forEach(function(c){
    c.addEventListener('click', function(e){ e.preventDefault();
      var id=c.getAttribute('data-shtp2-jump');
      if(id==='shtp2-pillows') pillowFilter('all');
      var el=document.getElementById(id); if(el) el.scrollIntoView({behavior:'smooth'});
    });
  });
  // guide options
  [].slice.call(scope.querySelectorAll('[data-shtp2-go]')).forEach(function(o){
    o.addEventListener('click', function(){
      var g=o.getAttribute('data-shtp2-go');
      if(g==='bolster'){ var b=document.getElementById('shtp2-bolsters'); if(b) b.scrollIntoView({behavior:'smooth'}); return; }
      if(g) pillowFilter(g);
      var p=document.getElementById('shtp2-pillows'); if(p) p.scrollIntoView({behavior:'smooth'});
    });
  });
  // installment modal
  var modal=scope.querySelector('[data-shtp2-modal]');
  if(modal){
    [].slice.call(scope.querySelectorAll('[data-shtp2-inst]')).forEach(function(b){ b.addEventListener('click', function(e){ e.preventDefault(); modal.hidden=false; }); });
    [].slice.call(modal.querySelectorAll('[data-shtp2-close]')).forEach(function(b){ b.addEventListener('click', function(){ modal.hidden=true; }); });
    document.addEventListener('keydown', function(e){ if(e.key==='Escape') modal.hidden=true; });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sh-topper-landing"] && !Shopify.designMode) return;
  try {
    
(function(){
  var root=document.currentScript ? document.currentScript.closest('.shopify-section') : null;
  var scope=(root||document).querySelector('.shtp');
  if(!scope) scope=document;
  function setupFilter(chipsKey, gridKey){
    var chipBox=scope.querySelector('[data-shtp-chips="'+chipsKey+'"]');
    var grid=scope.querySelector('[data-shtp-grid="'+gridKey+'"]');
    if(!chipBox||!grid) return function(){};
    var chips=[].slice.call(chipBox.querySelectorAll('.shtp-chip'));
    var cards=[].slice.call(grid.querySelectorAll('.shtp-card'));
    function apply(f){
      cards.forEach(function(c){ var t=c.getAttribute('data-tags')||''; c.style.display=(f==='all'||t.split(' ').indexOf(f)>-1)?'':'none'; });
      chips.forEach(function(x){ x.classList.toggle('is-active', x.getAttribute('data-shtp-filter')===f); });
    }
    chips.forEach(function(ch){ ch.addEventListener('click', function(){ apply(ch.getAttribute('data-shtp-filter')); }); });
    return apply;
  }
  var topFilter=setupFilter('topper','topper');
  [].slice.call(scope.querySelectorAll('[data-shtp-go]')).forEach(function(o){
    o.addEventListener('click', function(){
      var g=o.getAttribute('data-shtp-go');
      if(g) topFilter(g);
      var p=document.getElementById('shtp-grid'); if(p) p.scrollIntoView({behavior:'smooth'});
    });
  });
  var modal=scope.querySelector('[data-shtp-modal]');
  if(modal){
    [].slice.call(scope.querySelectorAll('[data-shtp-inst]')).forEach(function(b){ b.addEventListener('click', function(e){ e.preventDefault(); modal.hidden=false; }); });
    [].slice.call(modal.querySelectorAll('[data-shtp-close]')).forEach(function(b){ b.addEventListener('click', function(){ modal.hidden=true; }); });
    document.addEventListener('keydown', function(e){ if(e.key==='Escape') modal.hidden=true; });
  }
})();

  } catch(e) { console.error(e); }
})();
})();
